import React, { useState, useEffect } from 'react';
import ContentVideo from '@components/content-video/ContentVideo';
import FSBackIcon from 'src/assets/icons/arrow_back.svg?react';
import { useStandaloneContent } from '@src/hooks/useStandaloneContent';
import styles from './MaterialVideo.module.scss';

type Props = {
  data: string;
  isFullScreen: boolean;
  metaData?: {};
  onNext?: () => void;
  isPreview?: boolean;
  goBack?: () => void;
  startLesson?: () => void;
};

function MaterialVideo(props: Props) {
  const { data, isFullScreen, metaData, isPreview, goBack, startLesson } = props;
  const { isNewLessonLayout, isPlatformTower } = useStandaloneContent();
  const [replay, setReplay] = useState(isPreview ? false : true);

  useEffect(() => {
    if (isPreview && replay) {
      setReplay(false);
    }
  }, [isPreview, replay]);

  const handleSetReplay = () => {
    setReplay(true);
  }

  return (
     <div className={styles.wrapper}>
      <div className={styles.topBar}>
        <div className={styles.menuBar}>
          <button onClick={goBack} className={styles.closeButton} type={'button'}>
            <div className={styles.menuWrapper}>
            <FSBackIcon className={styles.closeIcon}/>
            </div>
          </button>
        </div>
      </div>
      <div className={styles.materialContent}>
        <ContentVideo
          data={data} metaData={metaData}
          isFullScreen={isFullScreen}
          autoPlay={false}
          isProgram={true}
          handleSetReplay={handleSetReplay}
          startLesson={startLesson}
          isNewLessonLayout={isNewLessonLayout}
          isPlatformTower={isPlatformTower}
        />
      </div>
    </div>
  );
}

export default MaterialVideo;
